module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    staticClass: "bg-white",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "hos-info-image"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hospitalInfo.image != ''),
      expression: "hospitalInfo.image != ''"
    }],
    attrs: {
      "src": _vm.hospitalImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hos-info-name"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "margin": "0"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.hospitalName) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-dsc"
  }, [_vm._v(_vm._s(_vm.hospitalInfo.desc))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62f3aa69","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/hospitalinfo/HosInfo.vue
// module id = 842
// module chunks = 0